const JORNADA = [
  { icon: 'ri-add-circle-line', label: 'Criar campanha' },
  { icon: 'ri-settings-3-line', label: 'Definir regras' },
  { icon: 'ri-git-merge-line', label: 'Integrar dados' },
  { icon: 'ri-check-double-line', label: 'Validar elegibilidade' },
  { icon: 'ri-gift-line', label: 'Premiar' },
  { icon: 'ri-bar-chart-box-line', label: 'Medir resultados' },
];

const CAMPANHA_REGRAS = [
  { regra: 'Plano empresarial de 20 vidas', premio: '2.000 pontos' },
  { regra: 'Novo contrato PME', premio: 'R$ 100' },
  { regra: 'Upgrade de plano', premio: 'R$ 50' },
  { regra: 'Contrato acima de 100 vidas', premio: 'R$ 500' },
];

const CROSS_SELL = [
  { antes: 'Plano A', acao: 'Upgrade para Plano B', premio: '1.000 pontos' },
  { antes: 'Cliente ativo', acao: 'Adesão a benefício adicional', premio: '500 pontos' },
];

export default function JornadaIncentivo() {
  return (
    <section id="jornada" className="scroll-mt-28 bg-background-50 py-20 md:py-28">
      <div className="mx-auto w-full max-w-[1240px] px-6">
        <div className="mx-auto mb-14 max-w-3xl text-center">
          <span className="inline-flex items-center rounded-full border border-primary-200 bg-primary-50 px-4 py-1.5 text-[11px] font-semibold uppercase tracking-[0.22em] text-primary-700">
            Como funciona
          </span>
          <h2 className="mt-5 font-heading text-3xl font-bold leading-[1.1] tracking-[-0.02em] text-foreground-950 md:text-5xl">
            Uma plataforma. <span className="text-primary-600">Múltiplas jornadas de incentivo.</span>
          </h2>
        </div>

        <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-6">
          {JORNADA.map((step, index) => (
            <div key={step.label} className="relative flex flex-col items-center gap-3 rounded-2xl border border-background-200 bg-background-50 p-5 text-center">
              <span className="flex h-12 w-12 items-center justify-center rounded-full bg-primary-100 text-primary-700">
                <i className={`${step.icon} text-xl`}></i>
              </span>
              <span className="text-sm font-semibold text-foreground-800">{step.label}</span>
              {index < JORNADA.length - 1 && (
                <span className="absolute -right-3 top-1/2 hidden -translate-y-1/2 text-foreground-300 lg:block">
                  <i className="ri-arrow-right-s-line text-xl"></i>
                </span>
              )}
            </div>
          ))}
        </div>

        <div className="mt-12 grid gap-5 lg:grid-cols-2">
          <article className="rounded-3xl border border-background-200 bg-background-100 p-7 md:p-8">
            <span className="inline-flex items-center gap-2 rounded-full bg-primary-100 px-3 py-1 text-xs font-semibold text-primary-700">
              <i className="ri-fire-line"></i>
              Campanha &quot;Venda que Premia&quot;
            </span>
            <h3 className="mt-5 font-heading text-xl font-bold text-foreground-950 md:text-2xl">
              Incentivo direto à venda de planos
            </h3>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600">
              A operadora ou administradora define a regra. A GetPoints controla o ciclo completo: contrato → regra →
              validação → crédito → resgate.
            </p>
            <div className="mt-6 space-y-3">
              {CAMPANHA_REGRAS.map((item) => (
                <div key={item.regra} className="flex items-center justify-between gap-4 rounded-xl border border-background-200 bg-background-50 px-4 py-3">
                  <span className="text-sm font-medium text-foreground-800">{item.regra}</span>
                  <span className="whitespace-nowrap rounded-full bg-primary-500 px-3 py-1 text-xs font-bold text-white">
                    {item.premio}
                  </span>
                </div>
              ))}
            </div>
          </article>

          <article className="rounded-3xl border border-background-200 bg-background-100 p-7 md:p-8">
            <span className="inline-flex items-center gap-2 rounded-full bg-accent-100 px-3 py-1 text-xs font-semibold text-accent-700">
              <i className="ri-arrow-up-circle-line"></i>
              Cross-sell e upgrade
            </span>
            <h3 className="mt-5 font-heading text-xl font-bold text-foreground-950 md:text-2xl">
              Crescimento dentro da carteira
            </h3>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600">
              Para administradoras e operadoras, campanhas que registram produto anterior → novo produto → campanha →
              elegibilidade → premiação.
            </p>
            <div className="mt-6 space-y-3">
              {CROSS_SELL.map((item) => (
                <div key={item.acao} className="flex items-center gap-4 rounded-xl border border-background-200 bg-background-50 px-4 py-3">
                  <span className="rounded-lg bg-secondary-100 px-2.5 py-1 text-xs font-semibold text-secondary-800">
                    {item.antes}
                  </span>
                  <span className="text-foreground-300">
                    <i className="ri-arrow-right-line"></i>
                  </span>
                  <span className="flex-1 text-sm font-medium text-foreground-800">{item.acao}</span>
                  <span className="whitespace-nowrap rounded-full bg-accent-500 px-3 py-1 text-xs font-bold text-white">
                    {item.premio}
                  </span>
                </div>
              ))}
            </div>
          </article>
        </div>
      </div>
    </section>
  );
}